module.exports = __webpack_public_path__ + "static/media/krx-trading-krx-04.e6175351.jpg";